const domain_import = {
	/* ------------------------- ADD DOMAIN TO RELATION ------------------------- */
	add_domain_to_relation: {
		details_not_matching:
			"Let op! De volgende problemen zijn opgetreden tijdens het importeren van de geselecteerde domeinnamen.",
		force_linking: "Geforceerd koppelen",
		relation_has_no_domain_details:
			"Let op! deze relatie bevat GEEN domein details, voeg deze eerst toe of gebruik een andere relatie. Je kan ook een relatie importeren uit hostfact.",
		title: "Relatie koppelen",
	},

	/* ------------------------------- DEBTOR LIST ------------------------------ */
	debtor_list: {
		description:
			"In onderstaande tabel zijn alle debiteuren uit HostFact te vinden die beschikken over een één of meerdere domeinnamen.",
		table: {
			body: {
				button: "Bekijk",
			},
			header: {
				company_name: "Bedrijfsnaam",
				debtor_code: "Debiteurnummer",
				domain_count: "Aantal domeinen",
				email_address: "E-mailadres",
				name: "Naam",
			},
		},
	},

	/* ------------------------------- DOMAIN LIST ------------------------------ */
	domain_list: {
		button: "{{count}} domein(en) toevoegen aan relatie",
		description:
			"In onderstaande tabel zijn alle domeinen van debiteur <strong>{{debtor_code}}</strong> te vinden. Wanneer deze al zijn toegevoegd aan het portaal kunnen ze niet nogmaals toegewezen worden.",
		discount_warning:
			"Let op! Controleer ALTIJD of een debiteur kortingen in HostFact heeft op één van zijn domeinen. Als dit het geval is, moet deze korting toegevoegd worden in de Portal VOORDAT het domein wordt geïmporteerd.",
		table: {
			body: {
				domain_fail:
					"Er is wat mis gegaan bij het importeren van domeinnaam <strong>{{domain}}</strong>, probeer het later nog eens of meld het probleem",
				domain_imported: "Domeinnaam <strong>{{domain}}</strong> is succesvol geïmporteerd.",
				domain_mismatch:
					"Er is een verschil gevonden tussen de details van de domeinhouder en de relatie tijdens het importeren van domeinnaam <strong>{{domain}}</strong>.",
				relation_bttn: "Relatie importeren",
				relation_fail:
					"Er is wat mis gegaan bij het importeren van deze hostfact contact, probeer het later nog eens of meld het probleem",
				relation_imported: "Hostfact contact succesvol geïmporteerd als relatie",
				relation_title: `Importeer hostfact handle als relatie. 
					- Debiteur: <strong>{{debtor_code}}</strong>. 
					- Relatie naam: <strong>{{name}}</strong> 
					- Domeinnaam: <strong>{{domain}}</strong>`,
			},
			header: {
				date_expiration: "Vervaldatum datum",
				date_registration: "Registratie datum",
				domain_name: "Domeinnaam",
				hostfact_handle: "HostFact Handle",
				naw: "NAW gegevens",
				oxxa_handle: "Oxxa Handle",
				relation: "Relatie",
			},
		},
	},
	/* --------------------------------- GENERAL -------------------------------- */
	title: "HostFact domeinen importeren",
};

export default domain_import;
